import api from 'utils/apiClient';

export const getRadarRanges = () => {
  return api.get('/radar_ranges', {
    headers: {
      Accept: 'application/json',
    },
    params: {
      pageSize: 1000,
    },
  });
};

export const addRadarRange = (data) => {
  return api.post('/radar_ranges', data);
};

export const deleteRadarRange = (id) => {
  return api.delete(`/radar_ranges/${id}`);
};